import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=cb281ae6&"
var script = {}
import style0 from "./Base.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports